export default __webpack_public_path__ + "static/media/news-actividad18.d9b44731.png";